import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Star, Building2, MapPin, UserRoundCheck } from "lucide-react";
import { SLUG, BIZ, ABOUT, SERVICE_GROUPS, REPUTATION } from "./psoData";
import PsoLayout, { NAVY, EMERALD, CREAM, SLATE } from "./PsoLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function PsoHome() {
  const basePath = `/${SLUG}`;
  return (
    <PsoLayout active="home">
      <section className="py-12 sm:py-16" style={{ background: "#E9EFEA" }} data-testid="pso-hero">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-[1.05fr_.95fr] border" style={{ borderColor: "#B8C9BF" }}>
          <div className="p-8 sm:p-12 lg:p-16 bg-white">
            <motion.p {...fadeUp} className="text-xs uppercase tracking-[0.2em] font-bold" style={{ color: EMERALD }}>PSO Accounting Group</motion.p>
            <motion.h1 {...fadeUp} className="mt-5 text-4xl sm:text-6xl font-extrabold leading-[1.02]" style={{ color: NAVY }}>Your Partner in Compliance</motion.h1>
            <motion.p {...fadeUp} className="mt-6 max-w-xl" style={{ color: SLATE }}>One firm, brought together from what used to be several near-identical websites — outsourced accounting, tax compliance, registration, payroll and audit for Philippine SMEs.</motion.p>
            <motion.div {...fadeUp} className="mt-9 flex flex-wrap gap-4">
            <a href={`${basePath}/contact`} data-testid="pso-hero-cta" className="rounded-md px-7 py-3.5 text-sm font-semibold" style={{ background: EMERALD, color: "white" }}>Ask About Your Books</a>
              <a href={`${basePath}/services`} data-testid="pso-hero-services" className="inline-flex items-center gap-2 rounded-md px-7 py-3.5 text-sm font-semibold border" style={{ color: NAVY, borderColor: "#A9BBB1" }}>See Services <ArrowRight size={16} /></a>
            </motion.div>
          </div>
          <aside className="p-8 sm:p-12 lg:p-14 flex flex-col justify-between" style={{ background: NAVY, color: "white" }}>
            <div className="grid sm:grid-cols-2 gap-px bg-white/15">
              <div className="p-5" style={{ background: NAVY }}><UserRoundCheck size={22} style={{ color: EMERALD }} /><p className="mt-4 text-xs uppercase tracking-wide text-white/55">Founder</p><strong className="mt-1 block">{ABOUT.founder}</strong></div>
              <div className="p-5" style={{ background: NAVY }}><Building2 size={22} style={{ color: EMERALD }} /><p className="mt-4 text-xs uppercase tracking-wide text-white/55">Built from</p><strong className="mt-1 block">Around 2015</strong></div>
            </div>
            <div className="mt-8 border-t border-white/15 pt-7">
              <p className="flex gap-2 items-center text-sm"><MapPin size={17} style={{ color: EMERALD }} />{BIZ.address}</p>
              <p className="mt-4 text-xs uppercase tracking-[0.16em] text-white/50">Service areas</p>
              <div className="mt-2 flex flex-wrap gap-2">{BIZ.serviceAreas.map((area) => <span key={area} className="border border-white/20 px-3 py-2 text-xs">{area}</span>)}</div>
            </div>
          </aside>
        </div>
      </section>

      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-6xl mx-auto px-5 sm:px-8">
          <motion.h2 {...fadeUp} className="text-2xl sm:text-3xl font-extrabold mb-10" style={{ color: NAVY }}>Services</motion.h2>
          <div className="border-t" style={{ borderColor: "#B8C9BF" }}>
            {SERVICE_GROUPS.map((g, index) => (
              <motion.div key={g.title} {...fadeUp} className="grid sm:grid-cols-[4rem_.7fr_1fr] gap-4 py-5 border-b items-start" style={{ borderColor: "#B8C9BF" }}>
                <span className="font-bold text-sm" style={{ color: EMERALD }}>{String(index + 1).padStart(2, "0")}</span>
                <h3 className="font-bold text-sm" style={{ color: NAVY }}>{g.title}</h3>
                <p className="text-xs" style={{ color: SLATE }}>{g.areas.join(" · ")}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-14" style={{ background: NAVY }}>
        <div className="max-w-2xl mx-auto px-5 sm:px-8 text-center">
          <div className="inline-flex items-center gap-1.5 mb-3">
            {[...Array(5)].map((_, i) => <Star key={i} size={18} fill={EMERALD} style={{ color: EMERALD }} />)}
          </div>
          <motion.p {...fadeUp} className="text-2xl font-extrabold text-white">{REPUTATION.rating}★ · {REPUTATION.reviewCountLabel}</motion.p>
        </div>
      </section>
    </PsoLayout>
  );
}
